import React, {PureComponent} from "react"

import Spacing from "@irati/ui/src/Spacing"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"

import Wrapper from "../Wrapper"
import SecondaryDetailsItem from "../Item"

interface Data {
  message?: string,
  userMessage?: string | JSX.Element
}

interface Props extends InjectIntl {
  className?: string,
  data: Data
}

class ViewMessage extends PureComponent<Props> {
  buildText = () => {
    const {data} = this.props
    return <>
      {data?.userMessage &&
        <Spacing marginBottom={data?.message?.length ? 2 : 0}>
          {data.userMessage}
        </Spacing>
      }
      {!!data?.message?.length && <FormattedMessage id="wallet.secondaryDetails.viewMessage.message" values={{message: data.message}} />}
    </>
  }

  render() {
    const {className} = this.props

    return (
      <Wrapper className={className || ""}>
        <SecondaryDetailsItem isFirstItem text={this.buildText()} />
      </Wrapper>
    )
  }
}

export default injectIntl(ViewMessage)
